"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable jsx-a11y/alt-text */
/* eslint-disable dot-notation */
/* eslint-disable react/button-has-type */
const react_1 = __importDefault(require("react"));
const Button_module_scss_1 = __importDefault(require("./Button.module.scss"));
function Button({ children, icon, variant = 'default', size = 'big', disabled = false, active = false, wide = false, onClick = () => {
    /* do nothing */
}, loading = false, 'data-testid': testId, }) {
    return (react_1.default.createElement("button", Object.assign({ className: Button_module_scss_1.default['button'], "data-size": size, "data-variant": variant, "data-active": active, "data-wide": wide, disabled: disabled, onClick: onClick, "data-loading": loading }, (testId !== undefined ? { 'data-testid': testId } : {})), loading ? (react_1.default.createElement("div", { className: Button_module_scss_1.default['loading-spinner'] })) : (react_1.default.createElement(react_1.default.Fragment, null,
        icon ? react_1.default.createElement("img", { className: Button_module_scss_1.default['icon'], src: icon }) : null,
        react_1.default.createElement("div", { className: Button_module_scss_1.default['content'] }, children)))));
}
exports.default = Button;
